'use client';

import React from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { LazyLoadImage } from '@depop/web-ui-kit/LazyLoadImage';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { formatPublishDate } from '@/modules/blog/helpers/formatPublishDate';

type Props = {
  slug: string;
  title: string;
  imgSrc?: string;
  imgAlt?: string;
  publishedAt?: string;
};

export function BlogArticleCard({
  slug,
  title,
  imgSrc,
  imgAlt,
  publishedAt,
}: Props) {
  return (
    <ExtendedLink href={`/blog/${slug}`} className={styles.card}>
      <div className={styles.imgContainer}>
        <LazyLoadImage className={styles.img} src={imgSrc} alt={imgAlt || ''} />
      </div>
      <Heading variant="sm" as="p" className={styles.title}>
        {title}
      </Heading>
      {publishedAt && (
        <Body variant="sm-regular" className={styles.publishedAt}>
          {formatPublishDate(publishedAt)}
        </Body>
      )}
    </ExtendedLink>
  );
}
